// extracted by mini-css-extract-plugin
export default {"InvertedTriangle":"InvertedTriangle_InvertedTriangle__IRSou"};